import { Check, Copy } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { useCopyToClipboard } from '../../../../hooks/useCopyToClipboard';

interface InviteLinkShareProps {
  link: string;
  email: string;
  onDone: () => void;
}

export function InviteLinkShare({ link, email, onDone }: InviteLinkShareProps) {
  const { copied, copy } = useCopyToClipboard();

  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <p className="text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground/80">
          Sign-in link
        </p>
        <div className="flex items-stretch gap-2">
          <code className="flex-1 overflow-x-auto rounded-xl border border-border/70 bg-secondary/60 px-3.5 py-2.5 font-mono text-[12.5px] text-foreground/90">
            {link}
          </code>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="shrink-0 self-stretch rounded-xl border border-border/70 bg-secondary/40 text-muted-foreground hover:bg-secondary hover:text-foreground"
            onClick={() => copy(link)}
            aria-label={copied ? 'Copied' : 'Copy to clipboard'}
            data-testid="copy-invite-link"
          >
            {copied ? (
              <Check className="h-4 w-4 text-primary" strokeWidth={1.6} />
            ) : (
              <Copy className="h-4 w-4" strokeWidth={1.6} />
            )}
          </Button>
        </div>
        <p className="text-sm text-muted-foreground">
          Share it however you like — access is granted automatically as soon as they sign in with{' '}
          <span className="font-medium text-foreground">{email}</span>. No invite email is sent.
        </p>
      </div>

      <div className="flex justify-end">
        <Button variant="tinted" shape="pill" size="sm" className="gap-1.5" onClick={onDone}>
          Done
        </Button>
      </div>
    </div>
  );
}
